exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-modal-content-details-qty-container .price {\n  margin: 0;\n}\n.product-modal-content-details-qty-container .price > div {\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n}\n.product-modal-content-details-qty-container .price > div .price-original {\n      font-size: 16px;\n}\n", ""]);

// exports
